import { render, staticRenderFns } from "./AlertsConfiguredWidgetComponent.vue?vue&type=template&id=24527ff6&"
import script from "./AlertsConfiguredWidgetComponent.vue?vue&type=script&lang=js&"
export * from "./AlertsConfiguredWidgetComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports